import { render, staticRenderFns } from "./create.vue?vue&type=template&id=4c6e6bb0&scoped=true"
import script from "./create.js?vue&type=script&lang=js&external"
export * from "./create.js?vue&type=script&lang=js&external"
import style0 from "./create.vue?vue&type=style&index=0&id=4c6e6bb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6e6bb0",
  null
  
)

export default component.exports